const { InnerBlocks } = wp.blockEditor;

export default ({ className }) => {
    return (
        <div className={`ButtonText ${ className }`}>
            <InnerBlocks.Content />
        </div>
    )
}
